var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2ed141;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384,512H128c-14.1,0-25.6-11.5-25.6-25.6V51.2c0-14.1,11.5-25.6,25.6-25.6h256c14.1,0,25.6,11.5,25.6,25.6 v435.2C409.6,500.5,398.1,512,384,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.2,115.2H204.8c-7.7,0-12.8-5.1-12.8-12.8V12.8C192,5.1,197.1,0,204.8,0h102.4c7.7,0,12.8,5.1,12.8,12.8 v89.6C320,110.1,314.9,115.2,307.2,115.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.9f02137ff6a7944f3870315470b72036.svg";
export { ForwardRef as ReactComponent };